import { OrganizationsModel } from '../models/organizations.model';
import RequestCreator from './helpers/requestCreator';

class Organization extends RequestCreator<OrganizationsModel> {}

const api = new Organization('/organizations');
export default api;
